(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__fiveWaysGrindSelectorV2) return;
  window.__fiveWaysGrindSelectorV2 = true;

  let frameId = 0;
  let followUpTimer = 0;
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const groundIsSelected = (root) => {
    const variantSelects = root.querySelector('variant-selects');
    if (variantSelects) {
      const checkedRadios = variantSelects.querySelectorAll('input[type="radio"]:checked');
      for (const radio of checkedRadios) {
        if (normalize(radio.value) === 'ground') return true;
      }
      const selects = variantSelects.querySelectorAll('select');
      for (const select of selects) {
        if (normalize(select.value) === 'ground') return true;
      }
    }
    const productInfo = root.querySelector('.product-information') || root;
    const text = normalize(productInfo.textContent).replace(/\s+/g, ' ');
    return /(?:bean type|grind size|grind)\s*:?\s*ground/.test(text);
  };

  const syncField = (field) => {
    const root = field.closest('.thb-product-detail') || field.closest('.product-section') || document;
    const select = field.querySelector('select[name="properties[Grind size]"]');
    if (!select) return;
    const isGround = groundIsSelected(root);
    field.style.display = isGround ? '' : 'none';
    select.disabled = !isGround;
    select.required = isGround;
    if (!isGround) select.value = '';
  };

  const syncAll = () => {
    document.querySelectorAll('[id^="CoffeeGrindField-"]').forEach(syncField);
  };

  const scheduleSync = () => {
    cancelAnimationFrame(frameId);
    clearTimeout(followUpTimer);
    frameId = requestAnimationFrame(syncAll);
    followUpTimer = window.setTimeout(syncAll, 250);
  };

  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('click', scheduleSync, true);
  document.addEventListener('product:variant-change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  window.addEventListener('pageshow', scheduleSync);

  const start = () => {
    syncAll();
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) scheduleSync();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    scheduleSync();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
